import script from "./ImportAssetRow.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportAssetRow.vue?vue&type=script&setup=true&lang=js"

import "./ImportAssetRow.vue?vue&type=style&index=0&id=6ae5e91e&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ae5e91e"]])

export default __exports__